import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const routeTitles: Record<string, string> = {
  '/': 'BeyondPages - Digitale Lösungen für Verlage',
  '/leistungen': 'Unsere Leistungen - BeyondPages',
  '/demos': 'Demos & Beispiele - BeyondPages',
  '/kontakt': 'Kontakt - BeyondPages',
  '/qr/login': 'Anmelden - BeyondPages QR Management',
  '/qr/dash': 'Dashboard - BeyondPages QR Management',
  '/qr/dash/': 'Dashboard - BeyondPages QR Management',
  '/qr/dash/links': 'QR-Codes verwalten - BeyondPages',
  '/qr/dash/statistics': 'Statistiken - BeyondPages',
  '/qr/dash/books': 'Bücher verwalten - BeyondPages',
  '/qr/dash/reports': 'Berichte - BeyondPages',
  '/qr/dash/profile': 'Profil - BeyondPages'
}

export const usePageTitle = () => {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname
    const title = routeTitles[path] || 'BeyondPages - QR Link Management'
    
    // Update document title
    document.title = title
    
    // Update meta description based on route
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      let description = 'BeyondPages - Professionelles QR-Code Management System für Verlage und Autoren.'
      
      if (path.includes('/qr/')) {
        description = 'Verwalten Sie QR-Codes, analysieren Sie Scan-Daten und optimieren Sie Ihre digitalen Marketingkampagnen.'
      } else if (path === '/leistungen') {
        description = 'Entdecken Sie unsere digitalen Lösungen für Verlage: QR-Code Management, Analytics und mehr.'
      } else if (path === '/kontakt') {
        description = 'Kontaktieren Sie BeyondPages für Ihre digitalen Verlagslösungen und QR-Code Management.'
      }
      
      metaDescription.setAttribute('content', description)
    }
  }, [location.pathname])
}

export default usePageTitle 